import React from "react";
import { Breadcrumbs } from "@material-tailwind/react";
import { Link, useNavigate } from "react-router-dom";
import { MdOutlineHomeWork } from "react-icons/md";
import { GiMoneyStack } from "react-icons/gi";
import { useState, useEffect } from "react";
import Loading from "../../COMPONENTS/Loading/Loading";
import { GoArrowLeft } from "react-icons/go";
import SidebarTop from "../SidebarTop";
import { IoMdPin } from "react-icons/io";
import { MdOutlineDateRange } from "react-icons/md";
import { BiSolidCategory } from "react-icons/bi";
import { value } from "@material-tailwind/react/types/components/chip";
import { FaBuilding, FaUser } from "react-icons/fa6";
import { IoIosAddCircle } from "react-icons/io";
import Trans from "../../../API/tourisme/transaction/index";
import { Custom, Fourniss, Services } from "../../../props";
import { toast, ToastContainer } from "react-toastify";
import { AiOutlineEdit } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { FaPhoneAlt } from "react-icons/fa";

function Ajout() {

  type Errors = {
    [key: string]: string; // ou autre type si ce n'est pas toujours un string
  };
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [service, setService] = useState<Services[]>([]);
  const [fourniss, setFourniss] = useState<Fourniss[]>([]);
  const [customers, setCustomers] = useState<Custom[]>([]);
  const [open, setOpen] = useState(false);
  const [opens,setOpens] = useState(false)
  const [errors,setErrors] = useState<Errors>({})
  const [errorsf,setErrorsF] = useState<Errors>({})
  const [errorsc,setErrorsC] = useState<Errors>({})

  let authUser: { userId: number } | null = JSON.parse(
    localStorage.getItem("data") || "null"
  );
  const [formData, setFormData] = useState({
    nom: "",
    dateach: "",
    lieu: "",
    montant: "",
    section: "",
    category: "",
    nomc: "",
    user: authUser?.userId,
  });

  const [formDataFourn,setFormDataFourn] = useState({
    fournisseur:'',
    phone:'',
    categorie:'',
    description:'',
    adresse:''
  })

  const [formDataCustomer,setFormDataCustomer] = useState({
    namec:'',
    lastnamec:'',
    phone:'',
    adresse:'',
    categorie:'',
    user: authUser?.userId,
  })

  const getAllService = () => {
    Trans.getService()
      .then((res: any) => {
        if (res.data.status === 200) {
          setService(res.data.services);
        }
      })
      .catch((err: any) => {
        console.log("Erreur lors de la recuperation ", err);
      });
  };

  const getAllFournisseur = () => {
    Trans.getFournisseur()
      .then((res: any) => {
        if (res.data.status === 200) {
          setFourniss(res.data.fournisseur);
        }
      })
      .catch((err: any) => {
        console.log("Erreur lors de l'appel a l'API ", err);
      });
  };

  const getAllCustomer = () => {
    Trans.getCustomer()
      .then((res: any) => {
        if (res.data.status === 200) {
          setCustomers(res.data.customers);
        }
      })
      .catch((err: any) => {
        console.log("Erreur lors de l'appel a l'API ", err);
      });
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleInputFournissChange = (e:any)=>{
     const {name,value} = e.target;
     setFormDataFourn((prevFourniss)=>({...prevFourniss,[name]:value}))
  }

  const handleInputCustomerChange = (e:any)=>{
     const {name,value} = e.target;

     setFormDataCustomer((prevCusto)=>({...prevCusto,[name]:value}))
  }

  const handleSubmit = (e: any) => {
    e.preventDefault();
    Trans.Submit(formData)
      .then((res: any) => {
        if (res.data.status === 200) {
          toast.success(res.data.message);
        }
        if(res.data.status === 422)
        {
          setErrors(res.data.errors)
          return;
        }
        navigate("/Dashboard/Transation");
      })
      .catch((err: any) => {
        console.log("Erreur lors de l'appel a l'API ", err);
      });
  };

  const handleFournissSubmit = (e:any)=>{
      e.preventDefault();
      Trans.storeFournisseur(formDataFourn)
           .then((res:any)=>{
                if(res.data.status === 200){
                    setFourniss(res.data.fournisseur)
                    setFormData({
                        ...formData,
                        nomc: String(res.data.newfourniss.Providers_Numbers)
                    })
                    toast.success("Fournisseur ajouter avec succes")
                    setOpen(!open)
                }
                if(res.data.status === 422)
                {
                  setErrorsF(res.data.errors)
                  return;
                }

                if(res.data.status === 403)
                {
                  toast.error(res.data.message)
                  return;
                }
           }).catch((err:any)=>{
            console.log("Erreur lors de l'appel a l'API ",err)
           })
  }

  const handleCustomerSubmit = (e:any)=>{
    e.preventDefault();
    Trans.storeCustomer(formDataCustomer)
         .then((res:any)=>{
             if(res.data.status === 200)
             {
                setCustomers(res.data.customers)
                setFormData({
                    ...formData,
                    nomc:res.data.newCustomer.Customers_Numbers
                })
                toast.success("Client ajouter avec succes")
                setOpens(!opens)
             }
             if(res.data.status === 422)
             {
              setErrorsC(res.data.errors)
              return;
             }
             if(res.data.status === 403)
             {
              toast.error(res.data.message)
              return;
             }
         }).catch((err:any)=>{
            console.log("Erreur lors de l'appel a l'API ",err)
         })
  }

  useEffect(() => {
    getAllService();
    getAllFournisseur();
    getAllCustomer();

    const timer = setTimeout(() => {
      // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
      setLoading(false);
    }, 2000); // 5000 millisecondes = 5 secondes

    // Nettoyer le timer si le composant est démonté avant la fin du délai
    return () => clearTimeout(timer);
  }, []);

   const {t} = useTranslation() as {t:(key:string)=>string}

  return (
    <div className="flex flex-row bg-[#eeee]">
      {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
          {/* sidebar left */}

          <div className="w-screen  barre_scroll h-screen">
            <ToastContainer />
            {/* navbar top orange */}
            <SidebarTop />
            {/* navbar top gris*/}
            <div className="bg-[#f7f7f7] sm:h-10 s:h-14 mt-[50px]">
              <Breadcrumbs>
                <Link to="" className="opacity-60 md:text-base s:text-xs">
                  Transation
                </Link>
                <Link
                  to="/Dashboard/Transation"
                  className="opacity-60 md:text-base s:text-xs"
                >
                  {t("Revenus & Depenses")}
                </Link>
                <Link to="" className="md:text-base s:text-xs">
                  {t("Ajouter")}
                </Link>
              </Breadcrumbs>
            </div>

            <Link to="/Dashboard/Transation">
              <div className="flex flex-row items-center space-x-2 relative top-8 s:left-5 sm:left-12 w-[280px]">
                <GoArrowLeft className="text-[#fe7f2d]  text-lg" />
                <p>{t("Retour à la page précedente")}</p>
              </div>
            </Link>
            {/* container formulaire */}
            <div className="flex justify-center py-20  ">
              <form
                onSubmit={handleSubmit}
                className="flex flex-col space-y-3 items-center  "
              >
                <div className="bg-white  s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px]  rounded-md border-b-8  shadow flex flex-col space-y-6 ">
                  {/* Titre */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlineHomeWork className="text-xl text-[#fe7f2d]" />
                      <label>{t("Titre")}</label>
                    </div>
                    <input
                      type="text"
                      name="nom"
                      placeholder="Ex : Restauration; Location de vehicule; Achat de ticket; Achat de materiel"
                      value={formData?.nom}
                      onChange={handleChange}
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.nom && <p className="text-red-500">{errors.nom}</p> }
                  </div>
                  {/* Date */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlineDateRange className="text-xl text-[#fe7f2d]" />
                      <label>{t("Date d'achat")}</label>
                    </div>
                    <input
                      type="date"
                      name="dateach"
                      value={formData?.dateach}
                      onChange={handleChange}
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.dateach && <p className="text-red-500">{errors.dateach}</p> }
                  </div>
                  {/* Lieu */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>{t("Lieu")}</label>
                    </div>
                    <input
                      type="text"
                      name="lieu"
                      placeholder="Ex : Cocody, Abidjan, Côte d'ivoire "
                      value={formData?.lieu}
                      onChange={handleChange}
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.lieu && <p className="text-red-500">{errors.lieu}</p> }
                  </div>

                  {/* categorie*/}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <BiSolidCategory className="text-xl text-[#fe7f2d]" />
                      <label>{t("Categorie")}</label>
                    </div>
                    <select
                      onChange={handleChange}
                      name="category"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value="">{t("Choisir la categorie")}</option>
                      <option value="1">{t("Depense")}</option>
                      <option value="2">{t("Vente")}</option>
                      {/* <option value="3">Autre</option> */}
                    </select>
                    {errors.category && <p className="text-red-500">{errors.category}</p> }
                  </div>
                  {formData.category === "1" && (
                    <div className="flex flex-col space-y-3">
                      <div className="flex flex-row items-center space-x-2">
                        <FaBuilding className="text-xl text-[#fe7f2d]" />
                        <label>{t("Fournisseur")}</label>
                      </div>
                      <div className="relative">
                          <div className="relative">
                            <select
                              onChange={handleChange}
                              value={formData?.nomc}
                              name="nomc"
                              className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4 pr-16"
                            >
                              <option value="">
                                {t("Veuillez choisir le fournisseur")}
                              </option>
                              {fourniss.map((four, index) => (
                                <option
                                  key={index}
                                  value={String(four?.Providers_Numbers)}
                                >
                                  {four?.Names}
                                </option>
                              ))}
                            </select>
                            <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-auto">
                              <IoIosAddCircle
                                className="text-xl text-[#fe7f2d]"
                                onClick={() => setOpen(!open)}
                              />
                            </div>
                          </div>
                          <div className="h-6">
                            {errors.nomc && <p className="text-red-500">{errors.nomc}</p>}
                          </div>
                        </div>
                    </div>
                  )}

                  {formData.category === "2" && (
                    <>
                      <div className="flex flex-col space-y-3">
                        <div className="flex flex-row items-center space-x-2">
                          <FaUser className="text-xl text-[#fe7f2d]" />
                          <label>{t("Client")}</label>
                        </div>

                        <div className="relative">
                        <select
                          onChange={handleChange}
                          value={formData?.nomc}
                          name="nomc"
                          className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                        >
                          <option value="">
                            {t("Veuillez choisir le client")}
                          </option>
                          {customers.map((custo, index) => (
                            <option
                              key={index}
                              value={String(custo?.Customers_Numbers)}
                            >
                              {custo?.Names + " " + custo?.LastName}
                            </option>
                          ))}
                        </select>
                        
                        <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                          <IoIosAddCircle
                            className="text-xl text-[#fe7f2d]"
                            onClick={() => setOpens(!opens)}
                          />
                        </div>
                       </div>
                       {errors.nomc && <p className="text-red-500">{errors.nomc}</p> }

                      </div>
                    </>
                  )}

                  {/* Montant */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <GiMoneyStack className="text-xl text-[#fe7f2d]" />
                      <label>{t("Montant")}</label>
                    </div>
                    <input
                      type="number"
                      name="montant"
                      placeholder="Ex : 400000 "
                      value={formData?.montant}
                      onChange={handleChange}
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.montant && <p className="text-red-500">{errors.montant}</p> }
                  </div>
                  {/* Section*/}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <BiSolidCategory className="text-xl text-[#fe7f2d]" />
                      <label>Section</label>
                    </div>
                    <select
                      onChange={handleChange}
                      value={formData?.section}
                      name="section"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value="">{t("Choisir la categorie")}</option>
                      {service.map((ser, index) => (
                        <option key={index} value={String(ser?.Items_Numbers)}>
                          {ser?.fr_Name}
                        </option>
                      ))}
                    </select>
                    {errors.section && <p className="text-red-500">{errors.section}</p> }
                  </div>
                </div>

                <button className="bg-[#FCCA46] w-[150px] h-10 rounded text-white">
                  {t("Ajouter")}
                </button>
              </form>
            </div>
          </div>

          {/* Modal d'ajout d'un fournisseur */}

          {open && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
              <div className="bg-white rounded-lg p-6 w-full max-w-3xl relative max-h-screen overflow-y-auto">
                {/* Bouton de fermeture à l'intérieur du modal */}
                <button
                  onClick={() => setOpen(false)}
                  className="absolute top-3 right-3 text-red-500 text-2xl"
                >
                  &times;
                </button>

                <h2 className="text-center text-xl font-semibold mb-4">
                  {t("Ajouter un fournisseur")}
                </h2>
                <div className="flex justify-center items-center w-full">
                  <div className="grid grid-cols-1 gap-4 max-w-lg">
                    <form onSubmit={handleFournissSubmit} className="flex flex-col items-center">
                      {/* Nom du fournisseur */}
                      <div className="flex flex-col space-y-3 w-full">
                        <div className="flex flex-row items-center space-x-2">
                           <FaUser className=" text-[#fe7f2d]" /> 
                          <label>{t("Nom du Fournisseur")}</label>
                        </div>
                        <input
                          type="text"
                          name="fournisseur"
                          placeholder="Ex : Banque"
                          value={formDataFourn?.fournisseur}
                          onChange={handleInputFournissChange}
                          className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                        />
                        {errorsf.fournisseur && <p className="text-red-500">{errorsf.fournisseur}</p>}
                      </div>

                      {/* Telephone du fournisseur */}
                      <div className="flex flex-col space-y-3 w-full mt-4">
                        <div className="flex flex-row items-center space-x-2">
                           <FaPhoneAlt className=" text-[#fe7f2d]" /> 
                          <label>{t("Telephone")}</label>
                        </div>
                        <input
                          type="text"
                          name="phone"
                          value={formDataFourn?.phone}
                          onChange={handleInputFournissChange}
                          className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                        />
                        {errorsf.phone && <p className="text-red-500">{errorsf.phone}</p>}
                      </div>

                      {/* Telephone du fournisseur */}
                      <div className="flex flex-col space-y-3 w-full mt-4">
                        <div className="flex flex-row items-center space-x-2">
                          <IoMdPin className="text-[#fe7f2d]" />
                          <label>{t("Adresse du Fournisseur")}</label>
                        </div>
                        <input
                          type="text"
                          name="adresse"
                          value={formDataFourn?.adresse}
                          onChange={handleInputFournissChange}
                          className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                        />
                        {errorsf.adresse && <p className="text-red-500">{errorsf.adresse}</p>}
                      </div>

                      {/* Categorie */}
                      <div className="flex flex-col space-y-3 mt-4">
                        <div className="flex flex-row items-center space-x-2">
                        <BiSolidCategory className="text-xl text-[#fe7f2d]" />
                        <label>{t("Categorie")}</label>
                        </div>
                        <select
                            onChange={handleInputFournissChange}
                            value={formDataFourn?.categorie}
                            name="categorie"
                            className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                        >
                        <option value="">{t("Choisir la categorie")}</option>
                        {service.map((ser, index) => (
                            <option key={index} value={String(ser?.Items_Numbers)}>
                            {ser?.fr_Name}
                            </option>
                        ))}
                        </select>
                        {errorsf.categorie && <p className="text-red-500">{errorsf.categorie}</p>}
                     </div>

                      {/* Description */}
                      <div className="flex flex-col space-y-3 w-full mt-4">
                        <div className="flex flex-row items-center space-x-2">
                          <AiOutlineEdit className="text-xl text-[#fe7f2d]" />
                          <label>Description</label>
                        </div>
                        <textarea
                          onChange={handleInputFournissChange}
                          value={formDataFourn?.description}
                          name="description"
                          className="xs:w-[500px] s:w-[230px] sm:w-[300px] rounded h-40"
                        ></textarea>
                        {errorsf.description && <p className="text-red-500">{errorsf.description}</p>}
                      </div>
                      <button className="bg-[#FCCA46] w-[150px] h-10 rounded text-white mt-4">
                        {t("Ajouter")}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/*Modal d'ajout d'un client*/}
          {opens && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
              <div className="bg-white rounded-lg p-6 w-full max-w-3xl relative max-h-screen overflow-y-auto">
                {/* Bouton de fermeture à l'intérieur du modal */}
                <button
                  onClick={() => setOpens(false)}
                  className="absolute top-3 right-3 text-red-500 text-2xl"
                >
                  &times;
                </button>

                <h2 className="text-center text-xl font-semibold mb-4">
                  {t("Ajouter un client")}
                </h2>
                <div className="flex justify-center items-center w-full">
                  <div className="grid grid-cols-1 gap-4 max-w-lg">
                    <form onSubmit={handleCustomerSubmit} className="flex flex-col items-center">
                      {/* Nom du client */}
                      <div className="flex flex-col space-y-3 w-full">
                        <div className="flex flex-row items-center space-x-2">
                           <FaUser className=" text-[#fe7f2d]" />
                          <label>{t("Nom du Client")}</label>
                        </div>
                        <input
                          type="text"
                          name="namec"
                          value={formDataCustomer?.namec}
                          onChange={handleInputCustomerChange}
                          className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                        />
                        {errorsc.namec && <p className="text-red-500">{errorsc.namec}</p>}
                      </div>

                       {/* Nom du client */}
                       <div className="flex flex-col space-y-3 w-full mt-4">
                        <div className="flex flex-row items-center space-x-2">
                          <FaUser className=" text-[#fe7f2d]" />
                          <label>{t("Prenom du Client")}</label>
                        </div>
                        <input
                          type="text"
                          name="lastnamec"
                          value={formDataCustomer?.lastnamec}
                          onChange={handleInputCustomerChange}
                          className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                        />
                        {errorsc.lastnamec && <p className="text-red-500">{errorsc.lastnamec}</p>}
                      </div>

                      {/* Telephone du fournisseur */}
                      <div className="flex flex-col space-y-3 w-full mt-4">
                        <div className="flex flex-row items-center space-x-2">
                          <FaPhoneAlt className=" text-[#fe7f2d]" />
                          <label>{t("Telephone")}</label>
                        </div>
                        <input
                          type="text"
                          name="phone"
                          value={formDataCustomer?.phone}
                          onChange={handleInputCustomerChange}
                          className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                        />
                        {errorsc.phone && <p className="text-red-500">{errorsc.phone}</p>}
                      </div>

                      {/* Telephone du fournisseur */}
                      <div className="flex flex-col space-y-3 w-full mt-4">
                        <div className="flex flex-row items-center space-x-2">
                          <IoMdPin className="text-[#fe7f2d]" />
                          <label>{t("Adresse du Client")}</label>
                        </div>
                        <input
                          type="text"
                          name="adresse"
                          value={formDataCustomer?.adresse}
                          onChange={handleInputCustomerChange}
                          className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                        />
                        {errorsc.adresse && <p className="text-red-500">{errorsc.adresse}</p>}
                      </div>

                      {/* Categorie */}
                      <div className="flex flex-col space-y-3 mt-4">
                        <div className="flex flex-row items-center space-x-2">
                        <BiSolidCategory className="text-xl text-[#fe7f2d]" />
                        <label>{t("Categorie")}</label>
                        </div>
                        <select
                            onChange={handleInputCustomerChange}
                            value={formDataCustomer?.categorie}
                            name="categorie"
                            className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                        >
                        <option value="">{t("Choisir la categorie")}</option>
                        {service.map((ser, index) => (
                            <option key={index} value={String(ser?.Items_Numbers)}>
                            {ser?.fr_Name}
                            </option>
                        ))}
                        </select>
                        {errorsc.categorie && <p className="text-red-500">{errorsc.categorie}</p>}
                     </div>
                     
                      <button className="bg-[#FCCA46] w-[150px] h-10 rounded text-white mt-4">
                        {t("Ajouter")}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Ajout;
